import React, { useState } from 'react';
import styles from './input-field.module.css';

// Images
import showPasswordImage from '../../images/password-show.svg';
import hidePasswordImage from '../../images/password-hide.svg';

// Helpers
import { toInputDate } from '../../helpers/string-format-helper';

type InputFieldProps = {
  type: string;
  inputId: string;
  label?: string;
  placeholder?: string;
  value?: any;
  validationMessage?: string;
  onChange?: (e: any) => void;
  inputContainerStyle?: object;
  inputStyle?: object;
};

function InputField(props: InputFieldProps) {
  const {
    label,
    placeholder,
    value,
    validationMessage,
    type,
    onChange,
    inputContainerStyle,
    inputStyle,
    inputId,
  } = props;

  var inputClass = `${styles.simpleField} title-2l`;
  if (validationMessage) {
    inputClass += ` ${styles.invalid}`;
  }

  const divMessage = (
    <div className={styles.validationMessage}>
      <span className='support-sb font-curiosity'>{validationMessage}</span>
    </div>
  );

  const defaultProperties = {
    className: inputClass,
    style: { width: '100%', ...inputStyle },
    value: value ? value : undefined,
    onChange: onChange,
    min: type === 'date' ? toInputDate(new Date()) : null,
    id: inputId,
  };

  const [showPassword, setShowPassword] = useState(false);
  const renderShowPasswordButton = () => {
    if (type === 'password') {
      return !showPassword ? (
        <img
          className={styles.showPasswordButton}
          src={showPasswordImage}
          alt='Mostrar senha'
          title='Mostrar senha'
          onClick={() => setShowPassword(!showPassword)}
        />
      ) : (
        <img
          className={styles.showPasswordButton}
          src={hidePasswordImage}
          alt='Esconder senha'
          title='Esconder senha'
          onClick={() => setShowPassword(!showPassword)}
        />
      );
    }

    return null;
  };

  const passwordType = showPassword ? 'text' : 'password';
  return (
    <div style={inputContainerStyle}>
      {label && (
        <div className={styles.fieldLabel}>
          <label className={`${styles.fieldLabel} title-3l`}>{label}</label>
        </div>
      )}
      <div className={styles.fieldInput}>
        {type === 'textarea' ? (
          <textarea
            placeholder={placeholder}
            {...defaultProperties}
            style={{
              ...defaultProperties.style,
              resize: 'none',
              height: '150px',
            }}
          />
        ) : (
          <input
            type={type === 'password' ? passwordType : type}
            placeholder={placeholder}
            {...defaultProperties}
            autoCapitalize={inputId === 'email' || inputId.includes('email') ? 'none' : undefined}
            autoCorrect={inputId === 'email' || inputId.includes('email') ? 'off' : undefined}
          />
        )}
        {renderShowPasswordButton()}
      </div>
      {!validationMessage ? '' : divMessage}
    </div>
  );
}

export default InputField;
